module.exports = __webpack_public_path__ + "static/media/conectado.ca79d260.svg";